import React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { DotsSixVertical } from '@phosphor-icons/react';
import Question from '../question';

const DraggableList = (props) => {
  const {
    list,
    Component,
    componentProps,
    onChange,
  } = props;

  const onReorderData = (result) => {
    if (!result.destination) return;

    if (list?.[result.destination.index]?.isPreset) return;

    const modifiedList = Array.from(list);
    const [moved] = modifiedList.splice(result?.source?.index, 1);
    modifiedList.splice(result?.destination?.index, 0, moved);

    onChange(modifiedList);
  };

  return (
    <DragDropContext onDragEnd={onReorderData}>
      <Droppable droppableId="droppable">
        {(providedParent) => (
          <div
            {...providedParent.droppableProps}
            ref={providedParent.innerRef}
            className="flex flex-col gap-5"
          >
            {list.map((item, index) => (
              <Draggable
                draggableId={String(index)}
                index={index}
                isDragDisabled={!!item?.isPreset}
              >
                {(provided) => (
                  <div
                    className="flex gap-2"
                    ref={provided.innerRef}
                    {...!item.disabled && ({ ...provided.draggableProps })}
                  >
                    <div
                      className="flex items-center justify-center"
                      {...provided.dragHandleProps}
                    >
                      <DotsSixVertical color={item?.isPreset ? '#E7E7E7' : '#101010'} />
                    </div>
                    <Component
                      {...item}
                      {...componentProps}
                      index={index}
                      className="flex-1"
                    />
                  </div>
                )}
              </Draggable>
            ))}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DraggableList;
